import { render, staticRenderFns } from "./detailCode.vue?vue&type=template&id=479a495f&scoped=true"
import script from "./detailCode.vue?vue&type=script&lang=js"
export * from "./detailCode.vue?vue&type=script&lang=js"
import style0 from "./detailCode.vue?vue&type=style&index=0&id=479a495f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a495f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479a495f')) {
      api.createRecord('479a495f', component.options)
    } else {
      api.reload('479a495f', component.options)
    }
    module.hot.accept("./detailCode.vue?vue&type=template&id=479a495f&scoped=true", function () {
      api.rerender('479a495f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/sendDriverInvitationCode/component/detailCode.vue"
export default component.exports